// Core
import React from 'react';

// Component
import { ImagePreviewProps } from './ImagePreview.types';
import {
  Container,
  Element,
  ImageBlur,
  ImageContainer,
  RemoveImage,
} from './ImagePreview.style';

// Layout
import { Col } from '../Col';
import { TrashCan } from '../../icons';

function ImagePreview({
  className,
  image,
  onRemove,
  testId,
}: ImagePreviewProps): JSX.Element {
  return (
    <Container
      className={className}
      data-testid={testId}
    >
      <Col>
        <ImageContainer>
          <Element src={image.source} alt={image.name} />
        </ImageContainer>
        <ImageBlur />
        <RemoveImage
          onClick={onRemove}
          type="link"
        >
          <TrashCan />
        </RemoveImage>
      </Col>
    </Container>
  );
}

export { ImagePreview };
